import React, {useEffect, useState} from 'react';
import '../QuestChestRewardModal/QuestChestRewardModal.css';
import './AppInstallRewardModal.css';
import PageButton from '../../elements/PageButton/PageButton';
import {ALL_CHEST_CONFIGS} from '../../../configs/chests';
import {getChestIconPath} from '../../../utils/inventory/getChestIconPath';
import {getChestDisplayName} from '../../../utils/inventory/getChestDisplayName';
import {ChestRewardLabel} from '../ChestPurchaseModal/ChestPurchaseModal';
import {MENU_SOUND_MANAGER} from '../../../scenes/MenuSoundManager';
import {WIN_POINTS_COLOR_LIGHT} from '../../../styles/constants';
import {sendPageEvent} from '../../../analytics/gameAnalytics';

const PAGE_ID = 'AppInstallRewardModal';

/**
 * Поздравление с наградой за первый вход через установленное приложение.
 * Сундук к этому моменту уже начислен сервером (см.
 * /api/users/me/app-install-reward) — модалка только показывает, что игрок
 * получил, и ведет в коллекцию открывать.
 *
 * Содержимое — как у наградного сундука за задание (QuestChestRewardModal):
 * обложка, название, таблица наград с вероятностями; отличаются заголовок и
 * набор кнопок
 */
const AppInstallRewardModal = ({chestId, onOpenInventory, onClose}) => {
  const [visible, setVisible] = useState(false);
  const chest = ALL_CHEST_CONFIGS.find((config) => config.id === chestId);

  useEffect(() => {
    MENU_SOUND_MANAGER.playChestOpen?.();
    // Показ награды за установку — отдельным событием: по нему видно, сколько
    // игроков реально дошло до первого входа через приложение
    sendPageEvent(PAGE_ID, 'mount');
    const timeoutId = setTimeout(() => setVisible(true), 50);
    return () => clearTimeout(timeoutId);
  }, []);

  if (!chest) {
    return null;
  }

  // reason — чем закрыли: кликом по фону или кнопкой. Кнопку «В коллекцию»
  // считает сам PageButton
  const handleClose = (reason) => {
    sendPageEvent(PAGE_ID, 'close', reason);
    setVisible(false);
    setTimeout(() => onClose?.(), 300);
  };

  return (
    <div
      className={`quest-chest-reward-overlay ${visible ? 'quest-chest-reward-overlay_visible' : ''}`}
      onClick={() => handleClose('overlay')}
      role={'dialog'}
      aria-modal={'true'}
      style={{'--chest-shadow-color': chest.shadowColor ?? WIN_POINTS_COLOR_LIGHT}}
    >
      <div
        className={`quest-chest-reward-modal ${visible ? 'quest-chest-reward-modal_visible' : ''}`}
        onClick={(event) => event.stopPropagation()}
      >
        <div className={'quest-chest-reward-content'}>
          <h2 className={'quest-chest-reward-congratulation'}>Приложение установлено!</h2>
          <div className={'quest-chest-reward-image-wrapper'}>
            <img
              className={'quest-chest-reward-image'}
              src={getChestIconPath(chest.id)}
              alt={getChestDisplayName(chest.id)}
            />
          </div>

          <p className={'quest-chest-reward-subtitle app-install-reward-modal_subtitle'}>
            Награда за первый вход через приложение:
          </p>

          <h3
            className={'quest-chest-reward-name'}
            style={{color: chest.textColor || chest.modalTextColor}}
          >
            {getChestDisplayName(chest.id)}
          </h3>

          <ul className={'chest-purchase-rewards-list'}>
            <li key={'header'} className={'chest-purchase-reward-row'}>
              <span className={'chest-purchase-reward-label chest-purchase-reward-label_neutral'}>Награда</span>
              <span className={'chest-purchase-reward-chance'}>Вероятность</span>
            </li>
            {/* Порядок как в магазине: самое ценное (в конфиге последнее) сверху */}
            {[...chest.rewards].reverse().map((reward, index) => (
              <li key={index} className={'chest-purchase-reward-row'}>
                <ChestRewardLabel reward={reward}/>
                <span className={'chest-purchase-reward-chance'}>{reward.chance}%</span>
              </li>
            ))}
          </ul>

          <div className={'main-menu-buttons quest-chest-reward-buttons'}>
            <PageButton onClick={onOpenInventory} pageId={PAGE_ID} buttonId={'open_inventory'}>
              Посмотреть в коллекции
            </PageButton>
            <PageButton
              className={'main-menu-button_secondary'}
              onClick={() => handleClose('button')}
              pageId={PAGE_ID}
              buttonId={'close'}
            >
              Скрыть
            </PageButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppInstallRewardModal;
